
import Ax from './axios'

let oldApiHost = process.env.oldApiHost

export const GetToken = (data) => {  // getToken
  	return Ax.post('wechat/GetToken', {...data}).then(
    	res => res.data
  	)
}

export function WxConfig (data) {  // 微信 JSSDK config
  	return Ax.post('wechat/GetJSSDK', {...data}).then(
    	res => res.data
  	)
}

export function AddFeedback (data) {  // 问题反馈
    return Ax.post('Faq/AddFeedback', {...data}).then(
        res => res.data
    )
}

export function GetRecentDailys(data) { // 获取近期知识更新日报
    return Ax.post('push/list', {
        ...data
    }).then(
        res => res.data
    )
}

// export function Logger (data) {  // 接口日志
//     return Ax.post('Faq/AddLog', {...data}).then(
//         res => res.data
//     )
// }


/////////  新版接口

export function GetFaqInterestsByUUID (data) {  // FAQ详情页 猜你感兴趣
    return Ax.post('Faq/GetFaqBykidNotInItself', {...data}).then(
        res => res.data
    )
}

export function GetFaqInterestsByKID (data) {  // 知识点详情页 猜你感兴趣
    return Ax.post('Knowledge/GetFaqBykid', {...data}).then(
        res => res.data
    )
}

export function GetKnowledgeInterestsByKID (data) {  // 知识点详情页 获取关联知识点
    return Ax.post('Knowledge/GetKnowledgeBykid', {...data}).then(
        res => res.data
    )
}

export function SendMail (data) {  // 知识点详情页 获取关联知识点
    return Ax.post('File/SendMail', {...data}).then(
        res => res.data
    )
}

export function CopyTextReport(data) { // 一键复制埋点
    return Ax.post('Statistics/OfficialContentCopy', {
        ...data
    }).then(
        res => res.data
    )
}

export function DailyUpdateReport(data) { // 进入知识日报埋点
    return Ax.post('Statistics/DailyUpdateReportViewData', {
        ...data
    }).then(
        res => res.data
    )
}

export function UpdateDailyReportViewData(data) { // 更新知识日报 埋点
    return Ax.post('Statistics/UpdateDailyReportViewData', {
        ...data
    }).then(
        res => res.data
    )
}

export function AddSearchMovementData(data) { // 知识日报埋点
    return Ax.post('Statistics/AddSearchMovementData', {
        ...data
    }).then(
        res => res.data
    )
}

export function UpdateSearchMovementData(data) { // 知识日报埋点
    return Ax.post('Statistics/UpdateSearchMovementData', {
        ...data
    }).then(
        res => res.data
    )
}


//--------------------分割线----------------------

export function AddKBDetailViewData(data) { // 进入知识详情埋点
    return Ax.post('/Statistics/AddKBDetailViewData', {
        ...data
    }).then(
        res => res.data
    )
}

export function UpdateKBDetailViewData(data) { // 知识点、faq详情进入相关常见问题  埋点接口
    return Ax.post('Statistics/UpdateKBDetailViewData', {
        ...data
    }).then(
        res => res.data
    )
}

export function AddNodeViewData(data) { // 进入知识目录  埋点接口
    return Ax.post('Statistics/AddNodeViewData', {
        ...data
    }).then(
        res => res.data
    )
}

export function UpdateNodeViewData(data) { // 知识目录点击节点、知识点  埋点接口
    return Ax.post('Statistics/UpdateNodeViewData', {
        ...data
    }).then(
        res => res.data
    )
}

export function AddTopicViewData(data) { // 新增专题埋点接口
    return Ax.post('Statistics/AddTopicViewData', {
        ...data
    }).then(
        res => res.data
    )
}

export function UpdateTopicViewData(data) { //  专题埋点接口
    return Ax.post('Statistics/UpdateTopicViewData', {
        ...data
    }).then(
        res => res.data
    )
}

export function DOP_ViewData(data) { //  视频下载埋点接口
    return Ax.post(process.env.dopHost, {
        ...data
    }).then(
        res => res.data
    )
}

export function DebugAuthUrl() {  // 跳转DebugUrl 添加鉴权参数
    return Ax.get('debug/url').then(
        res => res.data
    )
}

export function DebugSeekHelp(data) { // 点击求助跳转Debug埋点

    let urlParams = '?Token=' + localStorage.token + '&ADAccount=' + (localStorage.ADAccount || 'Null ADAccount') + '&TimeStamp=' + Date.now() + '&Position=' + data.Position

    return Ax.post('Statistics/AddDebugClickViewData' + urlParams).then(
        res => res.data
    )
}

export function enterpriseChat(data) { // 调用企微聊天数据埋点

    let urlParams = '?KBInfoId=' + data.KBInfoId + '&KBName=' + data.KBName + '&ChatUser=' + data.ChatUser + '&Owner=' + data.OwnerName + '&TimeStamp=' + Date.now()

    return Ax.post('Statistics/AddOpenEnterpriseChatViewData' + urlParams).then(
        res => res.data
    )
}


// WEBPACK FOOTER //
// ./src/api/common.js